const SummarySection = ({
  values,
  productLabel,
  warrantySummary,
  confirmChecked,
  invoiceFileName,
  invoiceValue,
  setConfirmChecked,
  isSubmitting,
  isFormReady,
}) => {
  const handlePrivacyPolicy = () => {
    window.open(
      "/AcrossAssist-PrivacyPolicy.html",
      "_blank",
      "noopener,noreferrer",
    );
  };
  const handleEW = () => {
    window.open(
      "/NeverOwned Extended Warranty TnC.html",
      "_blank",
      "noopener,noreferrer",
    );
  };
  const handleWar = () => {
    window.open(
      "/NeverOwned Warranty TnC.html",
      "_blank",
      "noopener,noreferrer",
    );
  };
  return (
    <section className="card summary-card">
      <h2 className="card__title">
        <span className="section-icon section-icon--gold">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </span>
        Registration Summary
      </h2>

      <div>
        <div className="summary-row">
          <span>Customer</span>
          <span className="summary-row__value">
            {values.customerName || "—"}
          </span>
        </div>

        <div className="summary-row">
          <span>Product</span>
          <span className="summary-row__value">{productLabel || "—"}</span>
        </div>

        <div className="summary-row">
          <span>Warranty Plan</span>
          <span className="summary-row__value summary-row__value--accent">
            {warrantySummary || "—"}
          </span>
        </div>

        <div className="summary-row">
          <span>Invoice Value</span>
          <span className="summary-row__value">
            {invoiceValue
              ? `${Number(invoiceValue).toLocaleString("en-IN")}`
              : "—"}
          </span>
        </div>

        {/* <div className="summary-row">
          <span>Invoice File</span>
          <span className="summary-row__value">{invoiceFileName || "—"}</span>
        </div> */}
      </div>

      <label className="confirm-check">
        <input
          type="checkbox"
          checked={confirmChecked}
          onChange={(e) => setConfirmChecked(e.target.checked)}
        />

        <span>
          I confirm that all information provided is correct and I accept the{" "}
          <a
            // href="warranty-terms-and-conditions"
            onClick={handleWar}
          >
            Warranty Terms & Conditions
          </a>{" "}
          ,{" "}
          <a
            // href="extended-warranty-terms-and-conditions"
            onClick={handleEW}
          >
            {" "}
            Extended Warranty Terms & Conditions
          </a>{" "}
          and
          <a
            // href="privacy-policy"
            onClick={handlePrivacyPolicy}
          >
            {" "}
            Privacy Policy{" "}
          </a>{" "}
          .
        </span>
        {/* <span>
          I confirm that all information provided is correct and I accept the{" "}
          <a href="#terms">Terms of Service</a> and{" "}
          <a href="#privacy">Privacy Policy</a>.
        </span> */}
      </label>

      <button
        type="submit"
        className="submit-btn"
        disabled={isSubmitting || !isFormReady}
      >
        {isSubmitting ? "Registering…" : "Register Warranty"}
      </button>

      {!isFormReady && !isSubmitting && (
        <p
          style={{
            textAlign: "center",
            fontSize: "0.8rem",
            color: "#888",
            marginTop: "8px",
          }}
        >
          Please fill in all required fields to register
        </p>
      )}
    </section>
  );
};

export default SummarySection;
